import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listKelasWaliKelas, setSelectedKelas } from '../../features/waliKelasSlice';
import Search from '../Search';

function ModalKelas({ onClose }) {
    const dispatch = useDispatch();
    const { listKelas } = useSelector((state) => state.waliKelas);
    const [search, setSearch] = useState('');
    const modalRef = useRef(null);

    useEffect(() => {
        dispatch(listKelasWaliKelas());
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    const filtered = listKelas.filter((k) =>
        k.category.toLowerCase().includes(search.toLowerCase())
    );

    function handleSelect(kelas) {
        dispatch(setSelectedKelas({ id: kelas.id, category: kelas.category }));
        onClose();
    }

    return (
        <div className='bg-modal'>
            <div className='modal-container' ref={modalRef}>
                <h1>Pilih Kelas</h1>
                <Search
                    placeholder='Cari kelas'
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={() => {}}
                />
                <div className='wrapper-list'>
                    {filtered.length === 0
                        ? <span>Kelas tidak ditemukan</span>
                        : filtered.map((item, index) => (
                            <div
                                className='container-list'
                                key={index}
                                onClick={() => handleSelect(item)}
                            >
                                <p>{item.category}</p>
                                <p>+</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export default ModalKelas;
